module.exports = __webpack_public_path__ + "img/rabbit-face.a39039b9.png";